function Uruguay({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2465)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 11.8263H31.4488C31.0476 10.3379 30.4379 8.93534 29.6516 7.65234H16V11.8263Z" fill="#338AF3"/>
  <path d="M6.0402 28.5216H25.9598C27.4199 27.3586 28.6722 25.946 29.6516 24.3477H2.34839C3.32783 25.9459 4.58008 27.3586 6.0402 28.5216Z" fill="#338AF3"/>
  <path d="M16 0V3.47825H25.9598C23.2267 1.3015 19.7656 0 16 0Z" fill="#338AF3"/>
  <path d="M16 11.8263H31.4488C31.0476 10.3379 30.4379 8.93534 29.6516 7.65234H16V11.8263Z" fill="#338AF3"/>
  <path d="M0 16C0 17.4442 0.1925 18.8431 0.551188 20.1739H31.4489C31.8075 18.8431 32 17.4442 32 16H0Z" fill="#338AF3"/>
  <path d="M13.913 9.36358L11.9589 10.2828L12.9994 12.1753L10.8776 11.7694L10.6087 13.9128L9.13082 12.3363L7.65282 13.9128L7.38401 11.7694L5.26213 12.1751L6.30263 10.2827L4.34863 9.36358L6.30269 8.44452L5.26213 6.55202L7.38394 6.95789L7.65288 4.81445L9.13082 6.39095L10.6088 4.81445L10.8776 6.95789L12.9995 6.55202L11.9589 8.44458L13.913 9.36358Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Uruguay;
